import { Menu, X, ChevronRight, Shield, Heart, Award, Users, Phone, Mail, Clock, Star, Target, TrendingUp, Briefcase } from "lucide-react";
import { useState } from "react";
import '../index.css';


export default function AboutUs() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Timeline data for company history
  const timelineEvents = [
    {
      year: "2022",
      title: "Foundation",
      description: "Optimal Actuarion LLC was founded with a mission to transform insurance accessibility."
    },
    {
      year: "2023",
      title: "Senior Focus Initiative",
      description: "Launched specialized programs designed specifically for senior citizens' unique needs."
    },
    {
      year: "2024",
      title: "Community Partnerships",
      description: "Established partnerships with local organizations to extend reach to underserved communities."
    },
    {
      year: "2025",
      title: "Expansion",
      description: "Growing our service offerings and digital presence to help more clients nationwide."
    }
  ];

  // Team members data
  const teamMembers = [
    {
      name: "Jane Smith",
      position: "Founder & CEO",
      description: "Insurance industry veteran with 15+ years experience in providing accessible coverage solutions."
    },
    {
      name: "Michael Johnson",
      position: "Senior Actuary",
      description: "Expert in risk assessment with a passion for creating fair and sustainable insurance models."
    },
    {
      name: "Sarah Williams",
      position: "Client Relations Director",
      description: "Dedicated to ensuring every client receives personalized care and optimal coverage solutions."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        {/* Announcement bar */}
        <div className="bg-gradient-to-r from-[#002D62] to-[#0077B6] text-white text-center py-2 text-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="font-semibold mr-2">Limited Time:</span> Get up to 30% off your first year of coverage. 
            <a href="/promotion" className="font-bold underline ml-1 hover:text-blue-100 transition-colors">Learn more</a>
          </div>
        </div>
        
        <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <div className="mr-2 text-[#0077B6]">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <span className="text-2xl font-extrabold bg-gradient-to-r from-[#002D62] to-[#0077B6] bg-clip-text text-transparent">Optimal Actuarion</span>
              </div>
              <nav className="hidden md:ml-10 md:flex md:space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Home</a>
                <a href="/#/about" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">About Us</a>
                <a href="/#/services" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Services</a>
                <a href="/#/quote" className="text-[#002D62] font-bold border-b-2 border-[#0077B6] px-1 pt-2 pb-1 transition-colors">Get a Quote</a>
                <a href="/#/faqs" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">FAQs</a>
                <a href="/#/testimonials" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Testimonials</a>
                <a href="/#/contact" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Contact</a>
              </nav>
            </div>
            <div className="flex items-center">
              <div className="hidden md:flex md:items-center md:space-x-4">
                <a href="/login" className="text-[#002D62] font-medium hover:text-[#0077B6] mr-4 transition-colors">Login</a>
                <a href="/quote" className="bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-6 py-3 rounded-md font-bold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
                  Get a Free Quote
                </a>
              </div>
              <div className="flex md:hidden">
                <button
                  type="button"
                  className="text-gray-700 hover:text-[#002D62] transition-colors"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  aria-expanded={mobileMenuOpen}
                >
                  {mobileMenuOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg animate-fadeIn">
            <div className="pt-2 pb-4 space-y-1 px-4">
            <a href="/" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Home</a>
              <a href="/#/about" className="block py-2 text-[#002D62] font-bold border-l-4 border-[#0077B6] pl-3">About Us</a>
              <a href="/#/services" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Services</a>
              <a href="/#/quote" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors ">Get a Quote</a>
              <a href="/#/faqs" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">FAQs</a>
              <a href="/#/testimonials" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Testimonials</a>
              <a href="/#/contact" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Contact</a>
             <div className="pt-4 pb-2 space-y-2">
                <a href="/login" className="block text-center text-[#002D62] font-medium hover:text-[#0077B6] py-2 transition-colors">
                  Login
                </a>
                <a href="/quote" className="w-full flex items-center justify-center bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-4 py-3 rounded-md font-bold shadow-md transition-all hover:shadow-lg">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </div>
        )}
      </header>

      <main>
        {/* Hero section */}
        <div className="relative bg-[#E8F1F9]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-[#002D62] leading-tight">
                About <span className="text-[#0077B6]">Optimal Actuarion</span>
              </h1>
              <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
                Transforming the insurance industry with a client-first approach focused on accessibility, inclusivity, and excellence.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-white"></div>
        </div>

        {/* Vision, Mission, Purpose section */}
        <div className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Our Foundation
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                The core values and principles that guide everything we do at Optimal Actuarion.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
              <div className="bg-[#E8F1F9] rounded-lg p-8 shadow-md transform transition-all duration-300 hover:-translate-y-2 hover:shadow-lg">
                <div className="inline-flex items-center justify-center p-3 bg-[#0077B6] rounded-full text-white mb-5">
                  <Star className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold text-[#002D62]">Vision</h3>
                <p className="mt-3 text-gray-700 leading-relaxed">
                  To ensure every individual, especially senior citizens, has access to affordable, reliable, and comprehensive health and life insurance, promoting inclusivity, equality, and peace of mind.
                </p>
              </div>

              <div className="bg-[#E8F1F9] rounded-lg p-8 shadow-md transform transition-all duration-300 hover:-translate-y-2 hover:shadow-lg">
                <div className="inline-flex items-center justify-center p-3 bg-[#0077B6] rounded-full text-white mb-5">
                  <Target className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold text-[#002D62]">Mission</h3>
                <p className="mt-3 text-gray-700 leading-relaxed">
                  To transform the insurance industry by solving the challenges of shortchanging and inadequate benefits. We provide accessible, fair policies through strategic partnerships and client-first service.
                </p>
              </div>

              <div className="bg-[#E8F1F9] rounded-lg p-8 shadow-md transform transition-all duration-300 hover:-translate-y-2 hover:shadow-lg">
                <div className="inline-flex items-center justify-center p-3 bg-[#0077B6] rounded-full text-white mb-5">
                  <TrendingUp className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-bold text-[#002D62]">Purpose</h3>
                <p className="mt-3 text-gray-700 leading-relaxed">
                  We aim to build a bridge between new insurance entities and providers, making dependable coverage available to all through simplicity, affordability, and community focus.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Story section */}
        <div className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="md:flex md:items-center md:space-x-10">
              <div className="md:w-1/2 mb-8 md:mb-0">
                <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden shadow-lg">
                  <div className="h-64 md:h-full w-full bg-gray-200 rounded-lg">
                    <img src="/api/placeholder/600/400" alt="Team meeting" className="object-cover w-full h-full rounded-lg" />
                  </div>
                </div>
              </div>
              <div className="md:w-1/2">
                <h2 className="text-3xl font-bold text-[#002D62]">Our Story</h2>
                <div className="mt-6 text-gray-700 space-y-4">
                  <p>
                    Founded with a passion for making insurance accessible to all, Optimal Actuarion LLC began with a simple yet powerful idea: insurance should be fair, transparent, and available to everyone regardless of their background or circumstances.
                  </p>
                  <p>
                    Our founders recognized a significant gap in the market, particularly for senior citizens and underserved communities who often struggle to find adequate coverage at reasonable rates. This realization sparked the creation of a company dedicated to bridging this gap.
                  </p>
                  <p>
                    Today, we continue to grow our services while maintaining our core commitment to inclusivity, affordability, and exceptional customer service. Every policy we offer is designed with our clients' unique needs in mind, ensuring that they receive the coverage they deserve.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline section */}
        <div className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Our Journey
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                Key milestones in our company's history
              </p>
            </div>

            <div className="relative">
              {/* Vertical line */}
              <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-[#0077B6]"></div>
              
              <div className="space-y-12">
                {timelineEvents.map((event, index) => (
                  <div key={index} className={`relative md:flex ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    {/* Year marker */}
                    <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full bg-[#0077B6] text-white flex items-center justify-center">
                      <span className="font-bold">{event.year}</span>
                    </div>
                    
                    {/* Content box */}
                    <div className={`md:w-5/12 bg-[#E8F1F9] p-6 rounded-lg shadow-md ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                      <div className="md:hidden mb-2 inline-block bg-[#0077B6] text-white px-3 py-1 rounded-full text-sm font-bold">
                        {event.year}
                      </div>
                      <h3 className="text-xl font-bold text-[#002D62]">{event.title}</h3>
                      <p className="mt-2 text-gray-700">{event.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Team section */}
        <div className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Our Team
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                Meet the dedicated professionals behind Optimal Actuarion
              </p>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md">
                  <div className="h-64 bg-gray-200">
                    <img src={`/api/placeholder/${300 + index}/${400 + index}`} alt={member.name} className="object-cover w-full h-full" />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-[#002D62]">{member.name}</h3>
                    <p className="text-[#0077B6] font-medium">{member.position}</p>
                    <p className="mt-3 text-gray-700">{member.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Values section */}
        <div className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Our Core Values
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                The principles that guide our work and relationships
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
              <div className="border border-[#0077B6] bg-white rounded-lg p-6">
                <div className="inline-flex items-center justify-center p-3 bg-[#E8F1F9] rounded-full text-[#0077B6] mb-4">
                  <Users className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-bold text-[#002D62]">Inclusivity</h3>
                <p className="mt-2 text-gray-700">
                  We believe everyone deserves access to quality insurance coverage, regardless of background or circumstances.
                </p>
              </div>

              <div className="border border-[#0077B6] bg-white rounded-lg p-6">
                <div className="inline-flex items-center justify-center p-3 bg-[#E8F1F9] rounded-full text-[#0077B6] mb-4">
                  <Heart className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-bold text-[#002D62]">Compassion</h3>
                <p className="mt-2 text-gray-700">
                  We approach every client with understanding and empathy, recognizing their unique needs and concerns.
                </p>
              </div>

              <div className="border border-[#0077B6] bg-white rounded-lg p-6">
                <div className="inline-flex items-center justify-center p-3 bg-[#E8F1F9] rounded-full text-[#0077B6] mb-4">
                  <Shield className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-bold text-[#002D62]">Integrity</h3>
                <p className="mt-2 text-gray-700">
                  We operate with transparency and honesty in all our dealings, building trust through ethical practices.
                </p>
              </div>

              <div className="border border-[#0077B6] bg-white rounded-lg p-6">
                <div className="inline-flex items-center justify-center p-3 bg-[#E8F1F9] rounded-full text-[#0077B6] mb-4">
                  <Award className="h-6 w-6" />
                </div>
                <h3 className="text-lg font-bold text-[#002D62]">Excellence</h3>
                <p className="mt-2 text-gray-700">
                  We strive for the highest standards in our services, continuously improving to better meet our clients' needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="bg-[#002D62] text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="md:flex md:items-center md:justify-between">
              <div className="md:w-2/3 mb-6 md:mb-0">
                <h2 className="text-2xl md:text-3xl font-bold">Want to learn more about our approach?</h2>
                <p className="mt-3 text-lg text-gray-200">
                  Schedule a consultation with our team to discuss how we can meet your insurance needs.
                </p>
              </div>
              <div className="md:w-1/3 flex justify-center md:justify-end space-x-4">
                <a href="/quote" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-[#002D62] bg-white hover:bg-gray-100">
                  Get a Quote
                </a>
                <a href="/contact" className="inline-flex items-center justify-center px-6 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-white hover:text-[#002D62] transition-colors">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#002D62] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Optimal Actuarion LLC</h3>
              <p className="mb-4">Insurance solutions for everyone, with a special focus on senior citizens and underserved communities.</p>
              <div className="flex flex-col space-y-2">
                <a href="/about" className="hover:text-gray-300">About Us</a>
                <a href="/services" className="hover:text-gray-300">Services</a>
                <a href="/testimonials" className="hover:text-gray-300">Testimonials</a>
                <a href="/faqs" className="hover:text-gray-300">FAQs</a>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Contact Information</h3>
              <div className="flex flex-col space-y-3">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Phone className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>972-891-8635</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Mail className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>OptimalActuarion@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Clock className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>Monday-Friday: 9:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Office Locations</h3>
              <div className="mb-4">
                <p className="font-medium">Primary Office:</p>
                <p>3221 Finley Road,</p>
                <p>Irving, TX 75062</p>
              </div>
              <div>
                <p className="font-medium">Business Address:</p>
                <p>4020 N MacArthur Blvd,</p>
                <p>Ste 122 #7156,</p>
                <p>Irving, TX 75038</p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-center text-sm">© {new Date().getFullYear()} Optimal Actuarion LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}